import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useTabs({
  defaultTab,
  paramKey = "tab",
  shouldTrack = false,
}: {
  defaultTab: string;
  paramKey?: string;
  shouldTrack?: boolean;
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedTab, setSelectedTab] = useState<string>(() => {
    const param = searchParams.get(paramKey);
    return param || defaultTab;
  });

  const onTabChange = (tab: string) => {
    setSelectedTab(tab);
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set(paramKey, tab);

      return newParams;
    });

    // if (shouldTrack) {
    // }
  };

  return {
    selectedTab,
    onTabChange,
  };
}
